import ReactTooltip, { TooltipProps } from 'react-tooltip'
import { FC } from 'react'
import classnames from 'classnames'

import Icon, { IconTypes } from '~ui/Icon'
import styles from './Tooltip.module.scss'

type TooltipBodyProps = {
  dataTip: string
  dataFor: string
  iconName?: IconTypes
}

export const TooltipBody: FC<TooltipBodyProps> = ({
  dataTip,
  dataFor,
  iconName = 'question-mark',
}) => (
  <span
    data-place="top"
    data-event="click"
    data-tip={dataTip}
    data-for={dataFor}
    className={styles['question-icon']}
  >
    <Icon name={iconName} width="1em" height="1em" />
  </span>
)

const Tooltip: FC<TooltipProps> = ({
  wrapper = 'span',
  globalEventOff = 'click',
  textColor = '#fff', // white
  backgroundColor = '#000', // black
  effect = 'solid', // with "float" effect tooltip might be rendered outside viewport
  className,
  ...props
}) => (
  <ReactTooltip
    effect={effect}
    wrapper={wrapper}
    textColor={textColor}
    arrowColor="transparent"
    className={classnames(styles.tooltip, className)}
    globalEventOff={globalEventOff}
    backgroundColor={backgroundColor}
    {...props}
  />
)

export default Tooltip
